import React from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Header from 'containers/PasswordRecoveryPages/Header';
import messages from 'containers/LoginRecoveryPage/InsertInfosPage/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/LoginRecoveryPage/InsertInfosPage/Form';
import { StyledPrimaryButton } from 'containers/LoginRecoveryPage/InsertInfosPage/styles';
import { pushTo } from 'helpers/routes';
import PAGES from 'routes/pages';
import { getErrorLoginRecoverySelector } from 'store/credentials/selectors';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const InsertInfos = (props: {
  intl: IntlShape;
  isLoading: boolean;
  onSubmitStep: Function;
  errorMessage?: string;
}) => (
  <GaLoadHOC
    category={EVENT_CATEGORIES.RECOVERY_LOGIN}
    label="chargement de la page"
  >
    <>
      <Header
        title={translate({ ...messages.formTitle }, props)}
        subTitle={translate({ ...messages.formSubTitle }, props)}
      />
      <Form onSubmit={props.onSubmitStep} errorMessage={props.errorMessage} />
      <Box paddingX={[2, 4, 8]}>
        <GaClickHOC
          category={EVENT_CATEGORIES.RECOVERY_LOGIN}
          label="Mot de passe oublié"
        >
          <StyledPrimaryButton
            data-testid="forgot-password"
            variant="outlined"
            onClick={() => pushTo(PAGES.RECOVERY_PASSWORD)}
          >
            {translate({ ...messages.passwordForgot }, props)}
          </StyledPrimaryButton>
        </GaClickHOC>
      </Box>
    </>
  </GaLoadHOC>
);

const mapStateToProps = createStructuredSelector<any, { errorMessage: string }>(
  {
    errorMessage: getErrorLoginRecoverySelector,
  },
);
export default connect(mapStateToProps, null)(injectIntl(InsertInfos));
